import React, { useState } from 'react';
import { TopBar } from './components/AmplifierControl/Index';
import { i18nService } from './i18n/i18nService';

const TestPage: React.FC = () => {
  const [isConnected, setIsConnected] = useState(true);
  const [isMcuConnected, setIsMcuConnected] = useState(true);
  const [language, setLanguage] = useState<'zh' | 'en' | 'jp'>('zh');

  const handleAntennaChange = (mode: 'manual' | 'auto') => {
    console.log('天线模式改变:', mode);
  };

  const handleTriggerModeChange = (mode: 'PTT1' | 'PP2' | '输入功率触发') => {
    console.log('触发模式改变:', mode);
  };

  const handleLanguageChange = (lang: 'zh' | 'en' | 'jp') => {
    setLanguage(lang);
    i18nService.setLanguage(lang);
    console.log('语言改变:', lang);
  };

  return (
    <div style={{ height: '100vh', backgroundColor: 'var(--color-bg-secondary)' }}>
      <TopBar
        isConnected={isConnected}
        isMcuConnected={isMcuConnected}
        onAntennaChange={handleAntennaChange}
        onTriggerModeChange={handleTriggerModeChange}
        onLanguageChange={handleLanguageChange}
      />

    </div>
  );
};

export default TestPage;